import React, { Component, lazy, Suspense } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { FiArrowLeft } from 'react-icons/fi';
import fnc from '../mymod/commFunction';
import { isParentAccount, isStudentAccount, isTeacherAccount } from '../mymod/accountRole';
import useStudentBankSession from '../studentQuestionBank/useStudentBankSession';
import { requestStudentStore, resolveStudentStoreImage } from './studentStoreApi';
import './StoreBook.scss';

const SharedStoreBook = lazy(() => import('../teacherLms/legacy/page_storeBook/StoreBook'));

class StoreErrorBoundary extends Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  render() {
    if (this.state.failed) return <div className="bookstore-message" role="alert">
      <p>교재 구매 화면을 불러오지 못했습니다.</p>
      <button type="button" onClick={() => window.location.reload()}>새로고침</button>
    </div>;
    return this.props.children;
  }
}

function StudentStorefront() {
  const { status, profile, retry } = useStudentBankSession();
  if (status === 'ready') return <StoreErrorBoundary key={profile.user.stCode}>
    <Suspense fallback={<div className="bookstore-message" role="status">교재 구매 화면을 불러오고 있습니다.</div>}>
      <SharedStoreBook request={requestStudentStore} resolveImage={resolveStudentStoreImage}
        learningPath="/lms/question-bank/exam" allowManagement={false} />
    </Suspense>
  </StoreErrorBoundary>;
  if (status === 'loading') return <div className="bookstore-message" role="status">계정을 확인하고 있습니다.</div>;
  if (status === 'unauthorized') return <div className="bookstore-message"><p>로그인 후 교재 구매를 이용해 주세요.</p><Link to="/login">로그인하기</Link></div>;
  if (status === 'forbidden') return <div className="bookstore-message"><p>학생 또는 강사 계정으로 이용해 주세요.</p><Link to="/menu">서비스 메뉴로</Link></div>;
  return <div className="bookstore-message" role="alert"><p>교재 구매 서비스에 연결하지 못했습니다.</p><button type="button" onClick={retry}>다시 시도</button></div>;
}

export default function StoreBook() {
  const loginState = useSelector(state => state.reduxStore) || {};
  const primary = loginState.userInfo || {};
  const currentUser = primary.id ? primary : loginState.userInfo2 || {};
  if (isParentAccount()) return <Navigate to="/menu" replace />;
  // The teacher workspace verifies its session and keeps its sidebar visible.
  if (isTeacherAccount(currentUser)) return <Navigate to="/teacher-lms/storeBook" replace />;
  const hasSession = Boolean(fnc.getCookie('appSessionToken'));
  return <main className="teacher-workspace bookstore-page" aria-label="교재 주문">
    <header className="bookstore-header"><Link to="/menu"><FiArrowLeft aria-hidden="true" />서비스 메뉴로</Link></header>
    <div className="bookstore-content">
      {isStudentAccount(currentUser) ? <StudentStorefront /> : <div className="bookstore-message">
        <p>{hasSession ? '학생 또는 강사 계정으로 이용해 주세요.' : '로그인 후 교재 구매를 이용해 주세요.'}</p>
        <Link to={hasSession ? '/menu' : '/login'}>{hasSession ? '서비스 메뉴로' : '로그인하기'}</Link>
      </div>}
    </div>
  </main>;
}
